var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.getPackage == 'normal' || _vm.isCoachlabLock)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(
    _vm.text === '' ? _vm.$t('Upgrade to {package} Plan', { package: _vm.$t('PREMIUM') }) : _vm.$t(_vm.text)
  ),expression:"\n    text === '' ? $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) : $t(text)\n  ",modifiers:{"top":true}}],staticClass:"premium",class:{ inline: _vm.inline == true, block: _vm.inline != true },on:{"click":function($event){return _vm.$router.push({
      name: 'Upgrade',
      path: '/upgrade'
    })}}},[_c('img',{staticStyle:{"width":"20px"},attrs:{"src":"/static/img/assets/_global/lock.svg","alt":""}}),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3468220a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PremiumLock.vue
// module id = null
// module chunks = 